// ERO Nutrition — GSAP Section Lifecycle Manager
// Must be loaded after GSAP and ScrollTrigger are available.
// Tracks all ScrollTrigger instances per Shopify section ID and
// cleans up GSAP + Draggable artifacts when a section unloads in
// the theme editor.
//
// Outside the theme editor the shopify:section:* events never
// fire, so the listeners below are inert. Viewport-cross cleanup
// (mobile ↔ desktop) is handled by each section's own
// gsap.matchMedia() callback, not by these handlers.

(function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  // Per-section ScrollTrigger registry. Sections opt in via
  // window.eroRegisterST(sectionId, st) when they need targeted
  // cleanup. The catch-all unload handler below also kills any
  // ScrollTriggers whose `trigger` element lives inside the
  // unloaded section, so registering is optional but cheap.
  window.eroScrollTriggers = new Map();

  window.eroRegisterST = function (sectionId, st) {
    if (!window.eroScrollTriggers.has(sectionId)) {
      window.eroScrollTriggers.set(sectionId, []);
    }
    window.eroScrollTriggers.get(sectionId).push(st);
  };

  if (!Shopify.designMode) return;

  // Kill explicitly-registered ScrollTriggers for the unloaded
  // section, then sweep up anything else GSAP-related inside the
  // section's DOM subtree. The two passes are intentional: the
  // registry catches triggers whose trigger element has already
  // been detached by the time the event fires (e.detail.sectionId
  // arrives before .shopify-section is removed, but section
  // markup can re-render in place), and the contains() pass
  // catches sections that don't bother registering.
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id) {
      var instances = window.eroScrollTriggers.get(id);
      if (instances) {
        instances.forEach(function (st) {
          try { st.kill(true); } catch (err) { /* trigger already detached */ }
        });
        window.eroScrollTriggers.delete(id);
      }
    }

    var root = e.target;
    if (!root) return;

    // Catch-all ScrollTrigger sweep — picks up any tween-bound
    // ScrollTriggers the section didn't register. `kill(true)`
    // also reverts pin spacers so the layout doesn't carry a
    // ghost gap after unload.
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.getAll()
        .filter(function (st) { return st.trigger && root.contains(st.trigger); })
        .forEach(function (st) {
          try { st.kill(true); } catch (err) { /* noop */ }
        });
    }

    // Kill every tween targeting an element inside the unloaded
    // section. Without this, an orphan tween can keep writing
    // transform values to a detached node and prevent garbage
    // collection of the section's DOM subtree.
    if (typeof gsap !== 'undefined') {
      var nodes = root.querySelectorAll('*');
      if (nodes.length) gsap.killTweensOf(nodes);
    }

    // Kill every Draggable instance whose target lives inside
    // the section. Draggable doesn't track instances globally so
    // we rely on Draggable.get(el) returning the instance for a
    // given element.
    if (typeof Draggable !== 'undefined') {
      var els = root.querySelectorAll('*');
      for (var i = 0; i < els.length; i++) {
        var d = Draggable.get(els[i]);
        if (d) {
          try { d.kill(); } catch (err) { /* noop */ }
        }
      }
    }
  });

  // Refresh ScrollTrigger after any section lifecycle event
  // that could change DOM layout or scroll position.
  ['shopify:section:load', 'shopify:section:reorder', 'shopify:section:select'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      ScrollTrigger.refresh();
    });
  });
})();
